import { render, staticRenderFns } from "./fishingPanel.vue?vue&type=template&id=ef8c2b2e&scoped=true&"
import script from "./fishingPanel.vue?vue&type=script&lang=js&"
export * from "./fishingPanel.vue?vue&type=script&lang=js&"
import style0 from "./fishingPanel.vue?vue&type=style&index=0&id=ef8c2b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8c2b2e",
  null
  
)

export default component.exports